
import { mapActions, mapGetters } from 'vuex';
import { appURLs, inAppRedirect } from '~/utils/route-redirects';
import { canCreatePortfolio } from '~/utils/behavior/portfolio-creation';

export default {
  name: 'NewsUpdateModal',
  emits: ['onValidate'],
  computed: {
    ...mapGetters('portfolio', ['myOwnedPortfolios']),
    ...mapGetters('authentication', [
      'isEmailConfirmed',
      'isVerifiedInfluencer',
    ]),
    canCreatePortfolio() {
      return canCreatePortfolio(
        this.isEmailConfirmed,
        this.myOwnedPortfolios.length,
        this.isVerifiedInfluencer
      );
    },
  },
  methods: {
    ...mapActions('modals', ['showCreatePortfolioModal']),
    ...mapActions('authentication', ['validateNewsUpdate']),
    async handleClick() {
      await this.validateNewsUpdate();
      this.canCreatePortfolio && this.showCreatePortfolioModal();
    },
    async handleBack() {
      await this.validateNewsUpdate();
      inAppRedirect(this.localePath(appURLs.feed()));
    },
  },
};
